<app-side-card>
  <div class="notes-outer-panel">
    <textarea
      (input)="checkMaxLength()"
      [formControl]="textAreaControl"
      [maxlength]="length"
      class="notes-card-textarea"
      placeholder="{{ 'Enter notes for this session' | translate }}"
    ></textarea>
    <div class="notes-divider">
      <div *ngIf="showAlert" class="notes-max-length-alert">
        {{ 'Maximum character limit reached' | translate }}
      </div>
      <app-action-button
        (click)="clearText()"
        *ngIf="hasData"
        color="accent"
        kind="filled"
        size="standard"
        type="button"
      >
        {{ 'Clear' | translate }}
      </app-action-button>
    </div>
  </div>
</app-side-card>
